import React, { useCallback } from 'react';
import { TouchableOpacity } from 'react-native';
import { hitSlopS } from 'design-system/values';
import IconBoldStar from 'design-system/icons/IconBoldStar';
import IconBoldStarFilled from 'design-system/icons/IconBoldStarFilled';
import { useAppSelector } from 'store/hooks';
import { assertUnreachable } from 'utils/types';
import { showContinueInMobileAlert } from 'features/pots/utils';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectIsInvestWalkthroughActive } from 'reducers/selectors/walkthrough';
import { isDesktop } from '../../../constants';
import { AddToWatchListModal } from './AddToWatchListModal';
import useStockWatchListInfo from '../hooks/useStockWatchListInfo';
import useNavigateToNextScreen from '../hooks/useNavigateToNextScreen';
import { useWatchlistCache, useIsAssetIdInWatchLists, useStatus, useRequiredUserAction } from '../hooks/selectors';
const AddToWatchListButton = ({ assetId }) => {
    const status = useStatus();
    const watchlists = useWatchlistCache();
    const requiredUserAction = useRequiredUserAction();
    const navigateToNextScreen = useNavigateToNextScreen();
    const { navigateDeprecated, popToTop } = useMainStackNavigation();
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const isInvestWalkthroughActive = useAppSelector(selectIsInvestWalkthroughActive);
    useStockWatchListInfo(assetId);
    const isInWatchLists = useIsAssetIdInWatchLists(assetId);
    const onButtonPress = useCallback(() => {
        if (scrambled)
            return;
        switch (status) {
            case undefined: {
                break;
            }
            case 'NOT_STARTED':
                navigateToNextScreen();
                break;
            case 'IDENTITY_CHECKS_IN_PROGRESS':
            case 'OPENING_IN_PROGRESS':
            case 'NOT_ELIGIBLE':
            case 'CLOSING_IN_PROGRESS':
            case 'CLOSED':
            case 'FROZEN':
            case 'JISA_CONVERTED':
            case 'JISA_TRANSFER_REQUIRED':
                popToTop();
                break;
            case 'IDENTITY_CHECKS_NEED_USER_ACTION': {
                if (isDesktop) {
                    showContinueInMobileAlert();
                }
                else {
                    switch (requiredUserAction) {
                        case 'UPLOAD_IDENTITY_DOCUMENT':
                            navigateDeprecated('WealthDocumentUploadIntroScreen', {
                                documentType: 'POI',
                            });
                            break;
                        case 'UPLOAD_PROOF_OF_ADDRESS':
                            navigateDeprecated('WealthDocumentUploadIntroScreen', {
                                documentType: 'POA',
                            });
                            break;
                        default:
                            popToTop();
                    }
                }
                break;
            }
            case 'ACTIVE':
                if (assetId) {
                    AddToWatchListModal.show(watchlists.length, assetId);
                }
                break;
            default:
                assertUnreachable(status);
        }
    }, [scrambled, status, assetId, requiredUserAction, watchlists.length]);
    return (<TouchableOpacity hitSlop={hitSlopS} onPress={onButtonPress} disabled={isInvestWalkthroughActive}>
      {isInWatchLists ? (<IconBoldStarFilled colorKey={isInvestWalkthroughActive ? 'brandOnModal' : 'brand'}/>) : (<IconBoldStar colorKey={isInvestWalkthroughActive ? 'primaryOnModal' : 'primary'}/>)}
    </TouchableOpacity>);
};
export default AddToWatchListButton;
